const tokensES = {
    "view": {
        "title": "Historial de tokens",
        "table": {
            "column": {
                "quantity": "Cantidad",
                "description": "Descripcion",
                "type": "Tipo",
                "balance": "Saldo",
                "date": "Fecha",
                "receipt": "Recibo"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "button": {
                "view": "Ver",
                "export_csv": "Exportar CSV",
                "order_tokens": "Pedir tokens"
            },
            "label": {
                "not_available": "No disponible",
                "credit": "Credito",
                "debit": "Debito"
            }
        }
    },
    "order": {
        "title": "Pedir tokens",
        "form": {
            "label": {
                "quantity": "Cantidad"
            },
            "placeholder": {
                "quantity": "Seleccionar cantidad"
            },
            "help": {
                "quantity": "Cantidad de tokens que desea pedir."
            },
            "validation": {
                "quantityRequired": "La cantidad es obligatoria"
            },
            "button": {
                "placeOrder": "Realizar pedido"
            },
            "option": {
                "tokensAmount": "{{count}} tokens"
            }
        },
        "modal": {
            "title": "Continuar al pago",
            "orderedPrefix": "Has pedido",
            "description": "Si desea confirmar el pedido, continue al pago. De lo contrario, puede cancelar el pedido.",
            "button": {
                "cancel": "Cancelar",
                "checkout": "Pagar"
            }
        },
        "message": {
            "error": "Algo salio mal. Actualice la pagina e intentelo de nuevo."
        }
    },
    "transaction": {
        "success": {
            "title": "Transaccion completada :)",
            "description": "Ha comprado los tokens correctamente y se agregaran a su cuenta en breve."
        },
        "cancel": {
            "title": "Transaccion cancelada :(",
            "description": "La transaccion fue cancelada... Intentalo de nuevo mas tarde."
        },
        "button": {
            "returnToDashboard": "Volver al panel"
        }
    }
};

export default tokensES;
